export type ExperimentVariant = {
  id: string;
  label: string;
  headline: string;
  body: string;
  primaryCta: string;
  primaryHref: string;
  secondaryCta?: string;
  secondaryHref?: string;
};

export type GrowthExperiment = {
  id: string;
  name: string;
  minVisitors: number;
  primaryMetric: string;
  guardrailMetric: string;
  variants: ExperimentVariant[];
};

export const growthExperiments: GrowthExperiment[] = [
  {
    id: 'home_hero_intent_v1',
    name: 'Homepage hero intent',
    minVisitors: 200,
    primaryMetric: 'cta_click',
    guardrailMetric: 'form_blocked',
    variants: [
      {
        id: 'shop_first',
        label: 'Shop first',
        headline: 'Pickleball spullen voor je eerste rally, training of clubavond.',
        body: 'Bekijk startersets, paddles, ballen, netten en accessoires uit onze eerste selectie. De verkoopbatch wordt voorbereid; je kunt producten bekijken, richtprijzen zien en een update of clubofferte aanvragen.',
        primaryCta: 'Bekijk eerste collectie',
        primaryHref: '/#live-drop',
        secondaryCta: 'Vraag clubpakket aan',
        secondaryHref: '/#clubs'
      },
      {
        id: 'choice_first',
        label: 'Choice first',
        headline: 'Begin met het juiste pickleball materiaal, niet met gokken.',
        body: 'Kies eerst op speelplek, niveau en aantal spelers. Daarna zie je welke set, paddle, bal of clubroute logisch is voor Nederland en Belgie.',
        primaryCta: 'Start keuzehulp',
        primaryHref: '/keuzehulp/',
        secondaryCta: 'Bekijk eerste collectie',
        secondaryHref: '/#live-drop'
      }
    ]
  },
  {
    id: 'seo_guide_cta_v1',
    name: 'SEO guide CTA framing',
    minVisitors: 200,
    primaryMetric: 'lead_form_start',
    guardrailMetric: 'no_result_view',
    variants: [
      {
        id: 'direct_products',
        label: 'Direct products',
        headline: 'Ga door naar de juiste productroute.',
        body: 'Gebruik de koopgids om meteen naar de passende collectie, keuzehulp of clubofferte te gaan.',
        primaryCta: 'Bekijk producten',
        primaryHref: '/producten/'
      },
      {
        id: 'decision_help',
        label: 'Decision help',
        headline: 'Nog niet zeker? Maak eerst je keuze kleiner.',
        body: 'Beantwoord de belangrijkste koopvragen voordat je een product of pakket kiest.',
        primaryCta: 'Start keuzehulp',
        primaryHref: '/keuzehulp/'
      }
    ]
  }
];

export function findGrowthExperiment(id: string): GrowthExperiment | null {
  return growthExperiments.find((experiment) => experiment.id === id) ?? null;
}
